import { render, staticRenderFns } from "./Realtimeorder.vue?vue&type=template&id=665551e4&scoped=true&"
import script from "./Realtimeorder.vue?vue&type=script&lang=js&"
export * from "./Realtimeorder.vue?vue&type=script&lang=js&"
import style0 from "./Realtimeorder.vue?vue&type=style&index=0&id=665551e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665551e4",
  null
  
)

export default component.exports